import { genericFetchingActionCreator } from '../../../actions/genericActionCreator'
import { catchCommonErrors } from '../../../actions/commonActionUtils'
import { getCookieValue } from '../../../actions/genericActionCreator'

export const fetchVeteranInfo = (searchValue) => {
  return (dispatch) => {
    dispatch(genericFetchingActionCreator('VIS', 'fetching'))
    fetch(`/lgyhub/api/vis-browser/search`, {
      credentials: 'include',
      method: 'POST',
      body: searchValue,
      headers: new Headers({
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'Veterans Information Solution')
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        dispatch(genericFetchingActionCreator('VIS', 'error'))
        throw new Error(responseJson.errors[0].message)
      } else { //success
        let list = { list: Object.values(responseJson) }
        if (list.list.length > 1) {
          dispatch(genericFetchingActionCreator('VIS', 'fetched', list))
        } else if (list.list.length < 1) {
          dispatch(genericFetchingActionCreator('VIS', 'error'))
        } else {
          dispatch(fetchVeteranProfile(responseJson[0].vaId))
        }
      }
    }).catch((error) => {
      console.error('VIS error: ', error)
    })
  }
}

export const fetchVeteranProfile = (vaId) => {
  return (dispatch) => {
    dispatch(genericFetchingActionCreator('VIS', 'fetching'))
    fetch(`/lgyhub/api/vis-browser/profile/${vaId}`, {
      credentials: 'include',
      method: 'GET'
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'Veterans Information Solution')
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        dispatch(genericFetchingActionCreator('VIS', 'error'))
        throw new Error(responseJson.errors[0].message)
      } else if (responseJson.veteran === null) {
        dispatch(genericFetchingActionCreator('VIS', 'error'))
      } else { //success
        dispatch(genericFetchingActionCreator('VIS', 'fetched', responseJson))
      }
    }).catch((error) => {
      console.error('VIS error: ', error)
    })
  }
}
